export default {
  en: {
    sms: "SMS",
    notifications: "Notifications",
    new_message: "New Message",
    message_templates: "Message Templates",
    log: "Message Log",
    phone: "Phone",
    short_code: "Short Code",
    text_message: "Message Content",
    clear: "Clear",
    failed: "Failed",
    sent: "Sent",
    sending_message: "Sending Message....",
    no_messages_sent_yet: "No message sent yet",
    select_template: "Select Template",
    recipient_number: "Recipient Number",
    no_logs: "No logs yet",
    error_messages: {
      content_required: "Message content is required",
      phone_min: "Phone number minimum is 10 digits",
      phone_max: "Phone number maximum is 12 digits",
      short_code_required: "Short Code is required",
      invalid_num: "Invalid phone number",
    },
  },
  ar: {
    sms: "الرسائل القصيرة",
    notifications: "إشعارات",
    new_message: "رسالة جديدة",
    log: "سجل الرسائل",
    message_templates: "القوالب الجاهزة",
    phone: "هاتف",
    short_code: "رمز قصير",
    text_message: "محتوى الرسالة",
    clear: "تفريغ",
    failed: "فشل الإرسال",
    sent: "نجح الإرسال",
    sending_message: "ارسال رسالة....",
    no_messages_sent_yet: "لم يتم إرسال أي رسالة حتى الآن",
    select_template: "اختر نموذج",
    recipient_number: "رقم المستقبل",
    send: "ارسال",
    no_logs: "لا يوجد سجلات حتى الآن",
    error_messages: {
      content_required: "محتوى الرسالة مطلوب",
      phone_min: "الحد الأدنى لرقم الهاتف هو 10 أرقام",
      phone_max: "الحد الأقصى لرقم الهاتف هو 12 رقمًا",
      short_code_required: "مطلوب رمز قصير",
      invalid_num: "رقم الهاتف غير صحيح",
      select_template: "يجب اختيار نموذج",
    },
  },
};
